import { HTTP } from './http';

export const getNomenclature = () => new Promise((resolve, reject) => HTTP.get(`/nomenclature`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const getReviewRequests = (url = false) => new Promise((resolve, reject) => HTTP.get(url || `/procedure_review_requests`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const getReviewRequestById = (id) => new Promise((resolve, reject) => HTTP.get(`/procedure_review_requests/${id}`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const getNextReview = () => new Promise((resolve, reject) => HTTP.get(`/procedure_reviews`)
  .then(response => ((response.status === 200 || 204) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const submitReview = model => new Promise((resolve, reject) => HTTP.post(`/procedure_reviews/${model.id}/review`, model)
  .then(response => ((response.status === 201) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestReviewId = (model) => new Promise((resolve, reject) => HTTP.post(`/procedure_review_requests`, model)
  .then(response => ((response.status === 201) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const getReviewRequestsDoctor = model => new Promise((resolve, reject) => HTTP.get(`/upload_requests`, model)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const getReviewRequestsDoctorById = id => new Promise((resolve, reject) => HTTP.get(`/upload_requests/${id}`)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const getOrder = id => new Promise((resolve, reject) => HTTP.get(`/order/${id}`)
  .then(response => ((response.status === 200 || 204) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestReviewPostInfo = model => new Promise((resolve, reject) => HTTP.post(`/upload_requests/${model.id}/answer`, model)
  .then(response => ((response.status === 200) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const submitPayment = model => new Promise((resolve, reject) => {
  HTTP.post(`/payment`, model)
    .then(response => ((response.status === 201) ? resolve : reject)(response))
    .catch(error => reject(error.response));
});

export const submitCouponCode = model => new Promise((resolve, reject) => HTTP.post(`/order/${model.order_id}/apply_coupon`, model)
  .then(response => ((response.status === 201) ? resolve : reject)(response))
  .catch(error => reject(error.response)));

export const requestReviewUploadImage = model => {
  const formData = new FormData();

  formData.append(`image`, model.image[0]);
  formData.append(`date`, model.date);
  formData.append(`category`, model.category);

  return new Promise((resolve, reject) => HTTP.post(`/upload_requests/${model.id}/files`, formData)
    .then(response => ((response.status === 200) ? resolve : reject)(response))
    .catch(error => reject(error.response)));
};



// WEBPACK FOOTER //
// ./client/api/review.js